import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

interface UseBlockedNavigationReturnProps {
  // eslint-disable-next-line
  handleBlockedNavigation: any;
  setConfirmedNavigation: React.Dispatch<React.SetStateAction<boolean>>;
  lastLocation: Location;
}

interface UseBlockedNavigationProps {
  onBlockedCallback?: () => void;
  allowedUrls?: string[];
  shouldBlockNavigation: boolean;
}

export const useBlockedNavigation = ({
  onBlockedCallback,
  allowedUrls,
  shouldBlockNavigation,
}: UseBlockedNavigationProps): UseBlockedNavigationReturnProps => {
  const history = useHistory();
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location>(location);

  const handleBlockedNavigation = (location: Location): boolean => {
    if (!confirmedNavigation && !allowedUrls?.includes(location.pathname)) {
      setLastLocation(location);

      if (onBlockedCallback) {
        onBlockedCallback();
      }
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      history.push(lastLocation?.pathname);
      setConfirmedNavigation(false);
    }
  }, [confirmedNavigation, lastLocation, history]);

  useEffect(() => {
    const unload = (event: BeforeUnloadEvent): void => {
      if (shouldBlockNavigation) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
        event.preventDefault(); // not fully supported yet
        event.returnValue = ''; // deprecated-ish
      }
    };

    window.addEventListener('beforeunload', unload);

    return (): void => window.removeEventListener('beforeunload', unload);
  }, [shouldBlockNavigation]);

  return {
    handleBlockedNavigation,
    setConfirmedNavigation,
    lastLocation,
  };
};
